import { Pipe, PipeTransform } from '@angular/core';


/**------------------------------------------------------
 * Filter the Array by Arguments passed
 * ------------------------------------
 * Takes 1 or 2 arguments and returns the filtered array by passed arguments.
 * Usage:
 * 	value (Array<string || number || boolean>) | ngFilter : ['arg1']
 *  value (Array<Object>) | ngFilter : ['arg1', 'arg2']
 *
 * Example:
 * 	{{ trademarkData | ngFilter: ['filed'] }}
 *  filter the "filed" data from trademarkData
 *
 * 	{{ mbaData | ngFilter: ['marketplace', 'com'] }}
 * 	filter the mbaData by 'marketplace' of "com" country
 */
@Pipe({
    name: 'ngFilter',
    standalone: false
})
export class NgFilterPipe implements PipeTransform {

	transform(value: Array<any>, args: string[]): any[] {

		//0 - if arguments are more 2 then return the data by checking the argument with first argument and compare with 2nd argument
		if (args.length === 2) return value.filter((elem: any) => elem[args[0]] === args[1]);

		//1 - if argument is only 1 then compare the data with first argument
		if (args.length === 1) return value.filter((elem: any) => elem === args[0]);

		//2 - check for arguments
		if (!args) throw new Error(`FilterPipe => transform => FATAL ERROR: FilterPipe needs filtering arguments and arguments cannot be empty args: ${args}`);

		//3 - check if length of arguments
		if (args.length > 2) throw new Error(`FilterPipe => transform => FATAL ERROR: FilterPipe can accept only max of 2 arguments: ${args.length}`);

		return [];
	}
}
